<h3>
  At a point in time the diagnostics component will be functional and displayed here.
</h3>
<!--
  <cx1ui-diagnostics></cx1ui-diagnostics>
 -->
